/* eslint-disable no-unused-vars */
export enum NotificationStatus {
  QUEUED = 0,
  SENT = 1,
  ALL = 2,
}
